import { gql } from '@apollo/client'
import { Account } from 'share/domain/account'

export const USER_LOGIN = gql`
  query tokenFromUsernameAndPassword(
    $password: String!
    $userId: String!
    $fromAccountCreationFlag: Boolean!
  ) {
    authentication {
      tokenFromUsernameAndPassword(
        pass: $password
        user: $userId
        fromAcctCreationFlag: $fromAccountCreationFlag
      ) {
        idToken
        accessToken
        expirationTime
        requiresMfa
        sessionId
        mfaDeliveryDestination
        unVerifiedMobilePhoneReset
        verifiedMobilePhone
        unVerifiedMobilePhone
        unVerifiedEmailAddressReset
        verifiedEmailAddress
        unVerifiedEmailAddress
        account {
          id
          givenName
          familyName
          middleName
          suffix
          homePhone
          mobilePhone
          workPhone
          userName
          emailAddress
          street
          zip
          city
          state
          ssn
          caseCount
          accountCreationStep
          contactType
        }
      }
    }
  }
`

export interface UserLoginVariables {
  userId: string
  password: string
  fromAccountCreationFlag: boolean
}

export interface UserLoginResponseData {
  idToken: string | null
  accessToken: string | null
  expirationTime: string | null
  requiresMfa: boolean
  sessionId: string | null
  success?: boolean
  error?: null | string
  account: Account
  mfaDeliveryDestination?: string | null
  unVerifiedMobilePhoneReset: boolean
  verifiedMobilePhone: string
  unVerifiedMobilePhone: string
  unVerifiedEmailAddressReset: boolean
  verifiedEmailAddress: string
  unVerifiedEmailAddress: string
}

export interface UserLoginResponse {
  authentication: {
    tokenFromUsernameAndPassword: UserLoginResponseData
  }
}

export const GET_REFRESH_TOKEN = gql`
  query {
    authentication {
      tokenFromRefreshToken {
        idToken
        accessToken
        expirationTime
      }
    }
  }
`

export const GET_REFRESH_TOKEN_ALL = gql`
  query {
    authentication {
      tokenFromRefreshToken {
        idToken
        accessToken
        expirationTime
        requiresMfa
        sessionId
        mfaDeliveryDestination
        account {
          id
          givenName
          familyName
          middleName
          suffix
          homePhone
          mobilePhone
          workPhone
          userName
          emailAddress
          street
          zip
          city
          state
          ssn
          caseCount
          accountCreationStep
          contactType
        }
      }
    }
  }
`

export interface RefreshTokenResponseData {
  idToken: string | null
  accessToken: string | null
  expirationTime: string | null
}

export interface RefreshTokenResponse {
  authentication: {
    tokenFromRefreshToken: RefreshTokenResponseData
  }
}

export interface RefreshTokenResponseAll {
  authentication: {
    tokenFromRefreshToken: UserLoginResponseData
  }
}
